export enum PatientDetailTabType {
  // The public route stays stable even though its visible label is Hormone Trends.
  HORMONE_CHARTS = 'hormone-charts',
  PATIENT_INFO = 'patient-info',
  PATIENT_REPORTS = 'reports',
  PATIENT_CALENDAR = 'calendar',
  RECOMMENDATIONS = 'recommendations',
}
